import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://futurefunder-5e4e4.firebaseio.com/projects'
});

export default axiosInstance;
